export const Aurora = ({ intensity = 'subtle', grain = true }) => {
  return (
    <div className="aurora-wrap" data-aurora={intensity} aria-hidden="true">
      <div className="aurora-blob" style={{
        width: '55vw', height: '55vw',
        background: 'var(--aurora-aqua)',
        top: '-15%', left: '-10%',
        animationDelay: '0s',
      }} />
      <div className="aurora-blob" style={{
        width: '50vw', height: '50vw',
        background: 'var(--aurora-pink)',
        top: '-20%', right: '-15%',
        animationDelay: '-7s',
      }} />
      <div className="aurora-blob" style={{
        width: '45vw', height: '45vw',
        background: 'var(--aurora-purple)',
        bottom: '-10%', left: '15%',
        animationDelay: '-14s',
      }} />
      <div className="aurora-blob" style={{
        width: '35vw', height: '35vw',
        background: 'var(--aurora-yellow)',
        bottom: '-5%', right: '5%',
        animationDelay: '-3s',
      }} />
      {grain && <div className="grain" />}
    </div>
  );
};
